import CustomZObject from './CustomZObject.js';
import {gl_uniform} from "zobject/definitions/gl/variables.js";
import {gl_vec2} from "zobject/definitions/gl/vec.js";
import ZMessage from "zobject/ZMessage.js";
import {NUMBER} from 'zobject/data-types.js';

const number = (z, n, min=-10, max=10) => {
    let _number = new ZMessage(z.subSequence, NUMBER);
    _number.text = n;
    _number.min = min;
    _number.max = max;
    return _number;
}

export default class Vec3 extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.x = number(this, 0);
        this.y = number(this, 0);
        
        this.zObject.hasInletFields = true;

        this.newInlet('x', ([msg]) => this.on(this.x, msg));
        this.newInlet('y', ([msg]) => this.on(this.y, msg));

        this.newOutlet("List");
        this.newOutlet("Vec2");

        let id = this.id.replaceAll('-', '');
        this.xUniform = gl_uniform({}, () => "vec2x" + id, () => true);
        this.yUniform = gl_uniform({}, () => "vec2y" + id, () => true);
        this.vec2 = gl_vec2(this.zObject, () => this.yUniform([this.y._text], true));
    }

    on(obj, val) {
        if (isNaN(val)) {
            return;
        }
        obj.text = val;
        this.sendObject();
    }

    sendObject() {
        let list = [this.x._text, this.y._text];

        let x = this.xUniform([this.x._text], true);
        let y = this.yUniform([this.y._text], true);
        this.sendMessage("List", list);
        this.sendMessage("Vec2", this.vec2([x]));
    }

    getJson() {
        return {
            ... super.getJson(),
            x: this.x._text,
            y: this.y._text,
        };
    }

    fromJson(json, copy) {
        super.fromJson(json, copy);

        this.x.text = json.x;
        this.y.text = json.y;
    }
 
}

